import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Button from 'react-bootstrap/Button';
import { useEffect, useState } from "react";
import { servicesApi } from "../service/apis/pages.api";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader/loader";

const OurServicesScreen = () => {
    const navigate = useNavigate();
    const [responseData, setResponseData] = useState<any>([]);
    const [titleSlug, setTitleSlug] = useState<any>(null);
    const [ , setIsLoading] = useState(false);

    const serviceContents = async() => {
        setIsLoading(true);
        try {
            const response = await servicesApi();
            //console.log(response);
            setResponseData(response?.pageData?.pageContent);
            setTitleSlug(response?.pageData);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        serviceContents();
    }, []);

    const decodeHtml = (html ="") => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }; 

    const sanitizeData = (htmldata = "") => {
        const sanitizedDescription = decodeHtml(htmldata);
        return (
          <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
        );
    };

    const recruit_texts = responseData[3]?.formFieldRepeater;
    const imig_texts = responseData[7]?.formFieldRepeater;

    return (
        <>
            {/* <HeaderScreen /> */}
            <div className="front-pages">
                <section className="home-banner innerBanner position-relative common-padd-xl">
                    <div className="homeLine"><img src={Innerbannerlines} alt="line icon" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="innerBanner-info text-center">
                                    {titleSlug && (
                                        <h1>{titleSlug?.title}</h1>
                                    )}
                                    <div className="breadcrumb-holder text-center">
                                        <Breadcrumb>
                                            <Breadcrumb.Item onClick={() => navigate('/')}><img src={Logoicon} alt="logo icon" /> Home</Breadcrumb.Item>
                                            <Breadcrumb.Item active>{titleSlug?.title}</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="our-services-area common-padd-xl pt-0">
                    <div className="container">
                    <div className="row">
                    <div className="col-lg-8 offset-2 mb-3 text-center">
                        {/* {responseData[0]?.type === "text" && responseData[0]?.content && (
                            <h2>{sanitizeData(responseData[0]?.content)}</h2>
                        )} */}
                        {responseData[1]?.type === "editor" && responseData[1]?.content && (
                            sanitizeData(responseData[1]?.content)
                        )}
                    </div>
                    </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="our-services-card">                                    
                                    <div className="our-services-card-Info">
                                        {responseData[2]?.type === "text" && responseData[2]?.content && (
                                            <h3>{responseData[2]?.content}</h3>
                                        )}
                                        <ul className="ticklist">
                                            {recruit_texts ? ( recruit_texts.map((rec: any, index: any) => (
                                                <li key={index}>{rec[0]?.content}</li>
                                            ))
                                        ) : (
                                            <Loader/>
                                        )}
                                        </ul>
                                        <Button onClick={() => navigate('/our-recruitment-services')} type="button" className="btn w-100 mb-5">{responseData[4]?.content}</Button>
                                    </div>
                                    {responseData[5]?.type === "image" && responseData[5]?.content && (
                                        <div className="ourSrvImg">
                                            <img src={responseData[5]?.content} alt="Services 1" />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="our-services-card">                                    
                                    <div className="our-services-card-Info">
                                        <h3>{responseData[6]?.content}</h3>
                                        <ul className="ticklist">
                                            {imig_texts ? ( imig_texts.map((imgr: any, index: any) => (
                                                <li key={index}>{imgr[0]?.content}</li>
                                                ))
                                            ) : (
                                                <Loader/>
                                            )}
                                        </ul>
                                        <Button onClick={() => navigate('/our-immigration-services')} type="button" className="btn w-100 mb-5">{responseData[8]?.content}</Button>
                                    </div>
                                    {responseData[9]?.type === "image" && responseData[9]?.content && (
                                        <div className="ourSrvImg"><img src={responseData[9]?.content} alt="Services 2" /></div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* <FooterScreen /> */}
        </>
    )
}
export default OurServicesScreen;